import React from 'react';
import { usePushNotifications } from '../contexts/usePushNotifications';
import { useNotificationsModalStore } from '../stores/useNotificationsModalStore';
import { EnableNotificationsModal } from './EnableNotificationsModal';

/**
 * Singleton controller component for the EnableNotificationsModal.
 * Renders once at the app level and controlled via useNotificationsModalStore.
 *
 * Usage:
 * 1. Render this component once at the root of your app
 * 2. Use the store to open/close the modal from anywhere:
 *
 * @example
 * const { openNotificationsModal } = useNotificationsModalStore();
 * openNotificationsModal(async () => {
 *   // Continue with the flow after notifications are handled
 * });
 */
export function EnableNotificationsModalController() {
  const { isOpen, onContinue, closeNotificationsModal } =
    useNotificationsModalStore();
  const { requestPermission } = usePushNotifications();

  const handlePress = async () => {
    await requestPermission();
    await onContinue?.();
    closeNotificationsModal();
  };

  return (
    <EnableNotificationsModal
      visible={isOpen}
      hide={closeNotificationsModal}
      onPress={handlePress}
    />
  );
}
